import React from 'react';
import { getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import S3Image from '../../S3Image';
import { AppConfig } from '../../../helpers/config';

const storageBucket = getOr('default', 'buckets.inventory', AppConfig);

const StorageImage = ({ image, ...restProps }) => (
  <S3Image {...restProps} bucket={storageBucket} image={image} />
);

StorageImage.propTypes = {
  image: PropTypes.string
};

StorageImage.defaultProps = {
  image: null
};

export default StorageImage;
